export default {
  // Page titles
  title: 'ลูกค้า',
  new_customer: 'เพิ่มลูกค้า',
  edit_customer: 'แก้ไขลูกค้า',
  customer_detail: 'รายละเอียดลูกค้า',

  // Descriptions
  description: 'จัดการผู้เช่าและผู้สนใจ',
  new_description: 'เพิ่มลูกค้าใหม่',
  edit_description: 'แก้ไขข้อมูลลูกค้า',

  // Labels
  labels: {
    first_name: 'ชื่อ',
    last_name: 'นามสกุล',
    phone: 'โทรศัพท์',
    email: 'อีเมล',
    id_card_number: 'บัตรประชาชน',
    tax_id: 'เลขประจำตัวผู้เสียภาษี',
    address: 'ที่อยู่',
    status: 'สถานะ',
    source: 'แหล่งที่มา',
    customer_info: 'ข้อมูลลูกค้า',
    lease_status: 'สถานะการเช่า',
    account_status: 'สถานะบัญชี',
    not_provided: 'ไม่ระบุ',
    leases_count: 'สัญญาเช่า ({{count}})',
  },

  // Placeholders
  placeholders: {
    first_name: 'ชื่อ',
    last_name: 'นามสกุล',
    phone: '0812345678',
    email: 'email@example.com',
    id_card_number: '1234567890123',
    tax_id: '0105XXXXXXXXX',
    address: 'เช่น 123 ถนนสุขุมวิท กรุงเทพฯ 10110',
    search: 'ค้นหาลูกค้า...',
    source: 'เลือกแหล่งที่มา...',
  },

  // Status
  status: {
    active: 'ใช้งาน',
    alumni: 'เคยเช่า',
    prospect: 'ผู้สนใจ',
    external: 'ผู้จอดรถภายนอก',
    all: 'ทุกสถานะ',
  },

  // Status tabs (lead generation)
  tabs: {
    all: 'ทั้งหมด',
    active: 'ใช้งาน',
    prospects: 'ผู้สนใจ',
    alumni: 'เคยเช่า',
    external: 'ภายนอก',
  },

  // LINE badge
  line_badge: 'LINE',

  // Lease section
  lease: {
    title: 'สัญญาเช่า',
    no_lease: 'ไม่มีสัญญาเช่า',
    no_lease_description: 'ลูกค้ารายนี้ไม่มีสัญญาเช่า',
    new_lease: 'สร้างสัญญาเช่า',
    create_lease: 'สร้างสัญญาเช่า',
    monthly_rent: 'ค่าเช่ารายเดือน',
    ongoing: 'ต่อเนื่อง',
    setup_guide_title: 'เชื่อมต่อลูกค้ากับห้อง',
    setup_guide_description:
      'สร้างสัญญาเช่าเพื่อมอบหมายลูกค้ารายนี้ให้กับห้อง ตรวจสอบให้แน่ใจว่ามีอสังหาริมทรัพย์พร้อมห้องว่างก่อน',
    step_1_title: 'เลือกห้องว่าง',
    step_1_description: 'เลือกห้องที่ว่างจากอสังหาริมทรัพย์ของคุณ',
    step_2_title: 'กำหนดเงื่อนไขสัญญา',
    step_2_description: 'กำหนดวันเริ่มต้น วันสิ้นสุด (ไม่บังคับ) และเงินประกัน',
    step_3_title: 'ลงนามสัญญา',
    step_3_description: 'บันทึกลายเซ็นผู้ให้เช่าและผู้เช่าเพื่อเปิดใช้งานสัญญา',
  },

  // Empty states
  empty: {
    title: 'ไม่มีลูกค้า',
    description: 'เริ่มต้นด้วยการเพิ่มลูกค้าคนแรก',
    no_results: 'ไม่พบลูกค้า',
  },

  // Setup guide
  setup_guide: {
    title: 'ยินดีต้อนรับสู่ลูกค้า',
    description:
      'ลูกค้าคือผู้เช่าและผู้สนใจของคุณ เพิ่มข้อมูลติดต่อที่นี่ จากนั้นมอบหมายให้กับห้องผ่านสัญญาเช่า',
    step_1_title: 'เพิ่มข้อมูลลูกค้า',
    step_1_description: 'กรอกชื่อ หมายเลขโทรศัพท์ อีเมล และเลขบัตรประชาชน',
    step_2_title: 'มอบหมายห้องผ่านสัญญาเช่า',
    step_2_description:
      'หลังจากเพิ่มลูกค้าแล้ว สร้างสัญญาเช่าเพื่อเชื่อมต่อกับห้องที่ต้องการ',
    import: 'นำเข้าจากไฟล์',
    import_off_scope_warning: 'พบ {{count}} แถว {{entity}} นำเข้าจากหน้า {{Entity}}',
    download_sample: 'ดาวน์โหลดตัวอย่าง',
    seed_sample: 'เพิ่มข้อมูลตัวอย่าง',
    seed_sample_confirm: 'ระบบจะสร้าง: ลูกค้าตัวอย่าง 1 ราย ต้องการดำเนินการต่อหรือไม่?',
    seed_sample_success: 'สร้างลูกค้าตัวอย่างสำเร็จ',
    seed_sample_noop: 'มีลูกค้าอยู่แล้ว ไม่ได้เพิ่มข้อมูลตัวอย่าง',
  },

  // Form sections (EP-86 T011 — Essentials/Advanced grouping)
  sections: {
    essentials: 'ข้อมูลหลัก',
    contact: 'ข้อมูลติดต่อ',
    ids: 'เอกสารระบุตัวตน',
    classification: 'การจัดกลุ่ม',
    advanced_options: 'ตัวเลือกเพิ่มเติม',
    // List page sort section header (EP-109 T903)
    recent: 'ล่าสุด',
  },

  // Status chips
  chips: {
    unpaid: 'ค้างชำระ',
  },

  // Actions
  actions: {
    add_customer: 'เพิ่มลูกค้า',
    create_customer: 'สร้างลูกค้า',
    import: 'นำเข้าข้อมูล',
  },

  // Messages
  messages: {
    delete_title: 'ลบลูกค้า',
    delete_confirm: 'ลบลูกค้า "{{name}}"? การกระทำนี้ไม่สามารถยกเลิกได้',
    created: 'สร้างลูกค้าสำเร็จ',
    updated: 'แก้ไขลูกค้าสำเร็จ',
    deleted: 'ลบลูกค้าสำเร็จ',
    not_found: 'ไม่พบลูกค้า',
    identifier_required: 'กรุณากรอกอย่างน้อยชื่อ เบอร์โทร หรืออีเมล เพื่อให้สามารถระบุลูกค้าได้',
    identifier_required_streamlined: 'กรุณากรอกอย่างน้อยชื่อหรือเบอร์โทร เพื่อให้สามารถระบุลูกค้าได้',
  },
}
